// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1Vb0Z","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1B4xD"};